import Button from '@ingka/button';
import InlineMessage from '@ingka/inline-message';
import arrowClockwiseIcon from '@ingka/ssr-icon/paths/arrow-clockwise';
import Text from '@ingka/text';
import { translate } from '@repo/phrase';

import { LoadingPage } from '@/components/loading';

import informationCircleIcon from '@ingka/ssr-icon/paths/information-circle';
import { SignaturesStatusView } from '../signatures-status-view/signatures-status-view.component';
import { useFetchSignatureStatus } from './signatures-modal-content.hooks';

import styles from './styles.module.scss';

interface Props {
    enabled?: boolean;
}

const RefreshButton = ({ onClick, loading }: { onClick: () => void; loading: boolean }) => (
    <div className={styles.refreshButton}>
        <Button
            type="tertiary"
            size="small"
            ssrIcon={arrowClockwiseIcon}
            text={translate('refresh')}
            onClick={onClick}
            loading={loading}
            aria-label={translate('refresh')}
        />
    </div>
);

export const SignaturesModalContent = ({ enabled = true }: Props) => {
    const { statusRows, showLoading, isEmpty, hasError, isFetching, refetch } = useFetchSignatureStatus(enabled);

    if (showLoading) {
        return <LoadingPage />;
    }

    return (
        <>
            <div className={styles.titleBar}>
                <Text tagName="h2" textStyle="Heading.XS">
                    {translate('orderview_signatures_title')}
                </Text>
                <RefreshButton onClick={() => void refetch()} loading={isFetching} />
            </div>

            {!isFetching && hasError && (
                <Text data-testid="signatures-full-error">{translate('docusign_fetch_error')}</Text>
            )}

            <hr />

            {isEmpty && (
                <InlineMessage subtle data-testid="signatures-empty-message" ssrIcon={informationCircleIcon}>
                    {translate('orderview_signatures_none')}
                </InlineMessage>
            )}

            {!isEmpty && !hasError && <SignaturesStatusView rows={statusRows} />}
        </>
    );
};
